import PropTypes from 'prop-types';
import React from 'react';
import CustomersWaiting from '../CustomersWaiting';
import BarberHoverMenu from '../BarberHoverMenu';
import { fullName } from '../../../../../common/helpers/users';
import TimeTrackingIcon from '../../../../timeTracker/containers/SideBySideTimeTrackingIcon';

const StickyName = ({ barber, stickyClass }) => (
  <div className={stickyClass}>
    <div className="c-calendar-dot-line c-calendar-dot-line--sticky-names" />
    <span className="c-calendar-dot" style={{ backgroundColor: barber.color }} />
    <BarberHoverMenu barber={barber}>
      <span
        className="c-calendar-combined-name-title"
        title={fullName(barber)}
        data-automation-id={`text:calendar:nameTitle:${barber.id}`}
      >
        {fullName(barber)}
      </span>
      <TimeTrackingIcon barberId={barber.id} />
      <CustomersWaiting barberId={barber.id} />
    </BarberHoverMenu>
  </div>
);

StickyName.propTypes = {
  stickyClass: PropTypes.string.isRequired,
  barber: PropTypes.object.isRequired, // eslint-disable-line
};

StickyName.defaultProps = {
  stickyClass: '',
};

export default StickyName;
